<template>
  <div class="card-material-library">
    <div class="library-body">
      <!-- 左侧：模块树（对齐 galaxy） -->
      <div class="module-tree">
        <div class="module-tree-header" @click="openModuleDialog()">
          <i class="el-icon-plus module-tree-add-icon"></i>
          <span class="module-tree-add-text">添加模块</span>
        </div>

        <div class="module-tree-content">
          <el-scrollbar class="module-tree-scroll">
            <el-tree v-if="moduleData && moduleData.length" ref="moduleTreeRef" node-key="id" :data="moduleData"
              :props="{ label: 'id', children: 'children' }" highlight-current :current-node-key="moduleId"
              @node-click="handleModuleNodeClick">
              <div class="module-tree-node" slot-scope="{ data }">
                <span class="module-tree-node-label" :title="getModuleName(data)">
                  {{ getModuleName(data) }}
                </span>
                <span class="module-tree-node-actions">
                  <i class="el-icon-remove module-tree-node-del" title="删除" @click.stop="deleteModule(data)"></i>
                  <i class="el-icon-edit module-tree-node-edit" title="编辑" @click.stop="openModuleDialog(data)"></i>
                </span>
              </div>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>

      <!-- 右侧：搜索 + 表格（对齐 galaxy） -->
      <div class="main-panel">
        <div class="search-bar">
          <el-form :inline="true" size="small" class="search-form">
            <el-form-item label="标题">
              <el-input v-model="searchForm.title" placeholder="请输入标题" clearable style="width: 180px;" />
            </el-form-item>
            <el-form-item label="标签">
              <el-select v-model="searchForm.tagIds" multiple filterable clearable placeholder="请选择"
                style="width: 200px;">
                <el-option v-for="t in tagOptions" :key="t.value" :label="t.label" :value="t.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="发布人">
              <el-select v-model="searchForm.publisherIds" multiple filterable clearable placeholder="请选择"
                style="width: 200px;">
                <el-option v-for="p in publisherOptions" :key="p.value" :label="p.label" :value="p.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="searchForm.resourceType" clearable placeholder="请选择" style="width: 140px;">
                <el-option label="模版" value="TEMPLATE" />
                <el-option label="贴纸" value="STICKER" />
                <el-option label="合集卡片" value="COLLECTION" />
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchForm.status" clearable placeholder="请选择" style="width: 140px;">
                <el-option label="未上线" :value="0" />
                <el-option label="上线" :value="1" />
                <el-option label="下线" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="排序">
              <el-select v-model="searchForm.customSort" clearable placeholder="请选择" style="width: 200px;">
                <el-option label="按添加时间（近-远）" value="createdAt#desc" />
                <el-option label="按添加时间（远-近）" value="createdAt#asc" />
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button @click="resetSearch">清空</el-button>
              <el-button type="primary" @click="handleSearch">搜索</el-button>
            </el-form-item>

            <div class="search-custom-btn">
              <el-button type="primary" @click="handleAddMaterial" :disabled="!moduleId">
                添加素材
              </el-button>
              <el-button type="primary" @click="toUploadData()">
                新增合集卡片
              </el-button>
            </div>
          </el-form>
        </div>

        <div class="table-area">
          <div class="table-wrapper">
            <el-table ref="tableRef" :data="dataList" border size="small" style="width: 100%" :height="tableHeight"
              v-loading="loading" row-key="id" :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }">
              <el-table-column type="index" label="序号" width="60">
                <template slot-scope="scope">
                  {{ (params.page - 1) * params.pageSize + scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="id" label="ID" />
              <el-table-column prop="resourceTypeText" label="类型" />
              <el-table-column label="缩略图" min-width="110" align="center">
                <template slot-scope="scope">
                  <div class="thumb-cell">
                    <el-image v-if="scope.row.thumbnailUrl" class="thumb-img" :src="scope.row.thumbnailUrl"
                      :preview-src-list="scope.row.thumbnailUrl ? [scope.row.thumbnailUrl] : []" fit="fill"
                      :z-index="3000" />
                    <span v-else class="thumb-placeholder"></span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="thumbnailBadgeText" label="缩略图角标" show-overflow-tooltip />
              <el-table-column prop="titleText" label="标题" show-overflow-tooltip />
              <el-table-column label="标签" min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="tag-wrap">
                    <div v-for="tag in (scope.row.tags || [])" :key="tag.id" class="tag-pill" :title="tag.name">
                      {{ tag.name }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="sloganText" label="宣传词" show-overflow-tooltip />
              <el-table-column prop="publisherName" label="发布人" show-overflow-tooltip />
              <el-table-column prop="pushText" label="推送配置" show-overflow-tooltip />
              <el-table-column prop="navText" label="跳转配置" show-overflow-tooltip />
              <el-table-column prop="createdAtText" label="创建时间" show-overflow-tooltip />
              <el-table-column prop="statusText" label="状态" />
              <!-- fixed="right" -->
              <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                  <div class="op-row">
                    <div class="op-drag">
                      <svg class="drag-btn" width="20" height="20" viewBox="0 0 48 48" fill="none"
                        xmlns="http://www.w3.org/2000/svg" @mouseenter="initSortable">
                        <path d="M8 18H40" stroke="currentColor" stroke-width="4" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M8 30H40" stroke="currentColor" stroke-width="4" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M8 6H40" stroke="currentColor" stroke-width="4" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M8 42H40" stroke="currentColor" stroke-width="4" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </div>
                    <template v-if="scope.row.resourceType === 'COLLECTION'">
                      <el-button type="primary" size="small" @click.stop="toUploadData(scope.row)">编辑</el-button>
                      <el-button :type="scope.row.status === 1 ? 'danger' : 'success'" size="small"
                        @click.stop="handleOffline(scope.row)">
                        {{ scope.row.status === 1 ? "下线" : "上线" }}
                      </el-button>
                      <el-button type="primary" size="small" @click.stop="openTest(scope.row)">测试</el-button>
                    </template>
                    <template v-else>
                      <el-button type="danger" size="small" @click.stop="removeResource(scope.row)">移出</el-button>
                      <el-button type="primary" size="small" @click.stop="copyLink(scope.row)">复制链接</el-button>
                    </template>
                    <el-button type="primary" size="small" @click.stop="openOptRecord(scope.row)">操作详情</el-button>

                  </div>
                </template>
              </el-table-column>
            </el-table>

          </div>
          <!-- 分页器 -->
          <div class="pager">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="params.page"
              :page-size="params.pageSize" :total="total" @current-change="pageChange" />
          </div>
        </div>
      </div>
    </div>

    <!-- 模块操作（新增/编辑） -->
    <el-dialog title="模块操作" :visible.sync="moduleDialogVisible" width="520px" :close-on-click-modal="false"
      destroy-on-close @closed="resetModuleForm">
      <el-form ref="moduleFormRef" :model="moduleForm" :rules="moduleFormRules" label-position="left" label-width="90px"
        class="module-form">
        <el-form-item required prop="name">
          <template slot="label">
            <span class="module-form-label">
              <span>模块命名</span>
            </span>
          </template>
          <div class="module-name-grid">
            <div class="module-name-row" v-for="item in moduleForm.name" :key="item.locale">
              <span class="module-name-lang">
                {{ item.locale === 'zh_CN' ? '简体' : (item.locale === 'zh_TW' ? '繁体' : '英文') }}
              </span>
              <el-input v-model="item.value" placeholder="请输入" />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="moduleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmModuleDialog">确定</el-button>
      </div>
    </el-dialog>

    <!-- 添加素材 -->
    <el-dialog title="添加素材" :visible.sync="addMaterialVisible" fullscreen custom-class="add-material-dialog"
      :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <add-material :moduleId="moduleId" :addMaterialVisible.sync="addMaterialVisible"
        @close="addMaterialVisible = false" @success="handleAddMaterialSuccess" />
    </el-dialog>

    <!-- 合集卡片上传/编辑（对齐 galaxy：居中弹窗、内部自带 footer） -->
    <el-dialog :title="`${uploadDetailId ? '编辑' : '新增'}合集卡片`" :visible.sync="uploadVisible" width="800px"
      :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close append-to-body
      @closed="handleUploadDialogClosed">
      <upload-data :moduleId="moduleId" :detailId="uploadDetailId" @close="handleUploadClose"
        @success="handleUploadSuccess" />
    </el-dialog>

    <!-- 操作详情 -->
    <el-dialog title="操作详情" :visible.sync="optRecordVisible" fullscreen custom-class="add-material-dialog"
      :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <opt-record :shipId="detailShipId" />
    </el-dialog>

    <!-- 测试 -->
    <el-dialog title="测试" :visible.sync="testVisible" width="500px" :close-on-click-modal="false"
      :close-on-press-escape="false" destroy-on-close>
      <test @confirm="testConfirm" @close="testVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import api from "@/api";
import { valueByLanguage, getDefaultLanguageData } from "@/utils/college";
import { getServerUrl } from "@/utils/serverUrl";
import AddMaterial from "./components/addMaterial/index.vue";
import OptRecord from "./components/optRecord/index.vue";
import UploadData from "./components/uploadData/index.vue";
import Test from "@/components/Test.vue";
import { calculateDynamicOrdinal, resetDataOrdinal } from "@/utils/ordinalUtils";
import { ConditionsTypeEnum, ConditionsDataTypeMap } from "@/components/PushConfig/usePushConditions";

export default {
  name: "CardMaterialLibrary"
  ,
  components: {
    AddMaterial,
    OptRecord,
    UploadData,
    Test
  },
  data() {
    return {
      loading: false,
      moduleData: [],
      moduleId: null,
      dataList: [],
      total: 0,
      params: {
        page: 1,
        pageSize: 20
      },
      addMaterialVisible: false,
      optRecordVisible: false,
      sortableInstance: null,
      // 模块 CRUD
      moduleDialogVisible: false,
      moduleDetails: null,
      moduleForm: {
        name: getDefaultLanguageData()
      },
      moduleFormRules: {
        name: [
          {
            validator(rule, value, callback) {
              const list = Array.isArray(value) ? value : [];
              const zhCN = list.find((x) => x && x.locale === "zh_CN");
              const zhTW = list.find((x) => x && x.locale === "zh_TW");
              const en = list.find((x) => x && x.locale === "en");
              if (!zhCN || !String(zhCN.value || "").trim()) {
                callback(new Error("请填写模块命名（简体）"));
              } else if (!zhTW || !String(zhTW.value || "").trim()) {
                callback(new Error("请填写模块命名（繁体）"));
              } else if (!en || !String(en.value || "").trim()) {
                callback(new Error("请填写模块命名（英文）"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      // 搜索
      searchForm: {
        title: "",
        tagIds: [],
        publisherIds: [],
        resourceType: "",
        status: "",
        customSort: ""
      },
      tagOptions: [],
      publisherOptions: [],
      // 详情/测试/上传
      detailShipId: null,
      testVisible: false,
      testDetailId: null,
      uploadVisible: false,
      uploadDetailId: null,
      tableHeight: 300
    };
  },
  watch: {
    moduleId() {
      this.params.page = 1;
      this.getList();
    }
  },
  mounted() {
    this.bootstrap();
    this.calcTableHeight();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    if (this.sortableInstance) this.sortableInstance.destroy();
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    getModuleName(m) {
      return valueByLanguage(m && m.name, "zh_CN", true) || (m && m.id) || "-";
    },
    async bootstrap() {
      await Promise.all([this.getTagOptions(), this.getPublisherOptions()]);
      await this.getModules();
    },
    async getTagOptions() {
      try {
        const res = await api.getMaterialTagList({ page: 1, pageSize: 1000 });
        const items = (res.data && res.data.items) ? res.data.items : [];
        this.tagOptions = items.map((it) => ({
          value: it.id,
          label: valueByLanguage(it.name, "zh_CN", true) || it.id
        }));
      } catch (e) {
        this.tagOptions = [];
      }
    },
    async getPublisherOptions() {
      try {
        const res = await api.getMaterialPublisherList({ page: 1, pageSize: 1000 });
        const items = (res.data && res.data.items) ? res.data.items : [];
        this.publisherOptions = items.map((it) => ({
          value: it.id,
          label: valueByLanguage(it.name, "zh_CN", true) || it.id
        }));
      } catch (e) {
        this.publisherOptions = [];
      }
    },
    async getModules() {
      const res = await api.getIndexConfigModulesList({
        page: 1,
        pageSize: 2000,
        resourceType: "RESOURCE",
        type: "2"  // BANNER = "1", CARD = "2"
      });
      this.moduleData = (res.data && res.data.items) ? res.data.items : [];
      if (this.moduleData.length && !this.moduleId) {
        this.moduleId = this.moduleData[0].id;
      }
    },
    handleModuleNodeClick(node) {
      this.moduleId = node && node.id;
      this.getList();
    },
    // ===== galaxy 显示映射（columns.ts 逻辑）=====
    getResourceTypeText(rt) {
      if (rt === "TEMPLATE") return "模版";
      if (rt === "STICKER") return "贴纸";
      if (rt === "COLLECTION") return "合集卡片";
      return rt || "-";
    },
    getOnlineStatusText(status) {
      // galaxy OnlineStatusEnum: 0 待上线, 1 上线, 2 下线
      const statusMap = { 0: "待上线", 1: "上线", 2: "下线" };
      return statusMap[status] || "-";
    },
    formatDateTime(val) {
      if (!val) return "-";
      const d = new Date(val);
      if (Number.isNaN(d.getTime())) return "-";
      const pad = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    getPushText(pushConditions) {
      const list = Array.isArray(pushConditions) ? pushConditions : [];
      const data = list.filter((it) => it && it.type === ConditionsTypeEnum.DATA);
      return (
        data
          .map((it) => ConditionsDataTypeMap[it.dataType] || it.dataType)
          .join("/") || "-"
      );
    },
    getNavText(navigationConfig) {
      const nav = navigationConfig || {};
      // 与 NavConfig.vue 枚举保持一致：0/1/2
      const navTypeMap = {
        0: "无跳转",
        1: "应用界面",
        2: "外部链接"
      };
      // 对齐 galaxy：对常见 appPage 进行中文目标映射（其余保持原值）
      const navTargetMap = {
        SecondLevelCategory: "二级分类页面",
        MaterialDetail: "资料/素材详情页",
        MemberCenter: "会员中心"
      };
      const navType = nav.navType;
      const appPage = nav.appPage;
      if (appPage) {
        return `${navTypeMap[navType] || navType}/${navTargetMap[appPage] || appPage}`;
      }
      return navTypeMap[navType] || navType || "-";
    },
    async hydrateCardThumb(items) {
      // 对齐 galaxy：处理缩略图 URL
      // STICKER, TEMPLATE 类型使用 thumbnail[0].value（直接是 URL 字符串）
      // COLLECTION 类型使用 bgFileAssetId（优先 url，否则 value 可能是 URL 或 ID）
      const itemsWithUrl = items.map((row) => {
        // COLLECTION 类型使用 bgFileAssetId
        if (row.resourceType === "COLLECTION") {
          const bgFileAsset = row.bgFileAssetId;
          if (!bgFileAsset || !Array.isArray(bgFileAsset)) {
            return { ...row, thumbnailUrl: "" };
          }
          // 查找 zh_CN 的 fileAsset
          const zhAsset = bgFileAsset.find((item) => item.locale === "zh_CN");
          // 如果直接有 url，使用 url
          if (zhAsset && zhAsset.url) {
            return { ...row, thumbnailUrl: zhAsset.url };
          }
          // 如果有 value，判断是 URL 字符串还是 ID
          if (zhAsset && zhAsset.value) {
            // 如果是数字字符串，需要通过 API 查询
            const numValue = Number(zhAsset.value);
            if (!isNaN(numValue) && String(numValue) === String(zhAsset.value)) {
              return { ...row, fileAssetIdValue: numValue, thumbnailUrl: "" };
            }
            // 否则 value 本身就是 URL 字符串
            return { ...row, thumbnailUrl: zhAsset.value };
          }
          return { ...row, thumbnailUrl: "" };
        } else {
          // STICKER, TEMPLATE 类型使用 thumbnail[0].value（直接是 URL 字符串）
          const thumbnail = row.thumbnail;
          if (!thumbnail || !Array.isArray(thumbnail) || !thumbnail.length) {
            return { ...row, thumbnailUrl: "" };
          }
          const firstThumb = thumbnail[0];
          // value 直接就是 URL 字符串
          if (firstThumb && firstThumb.value) {
            return { ...row, thumbnailUrl: firstThumb.value };
          }
          return { ...row, thumbnailUrl: "" };
        }
      });

      // 收集需要查询的 ID（只有 COLLECTION 类型且 value 是数字的情况）
      const idsToQuery = itemsWithUrl
        .filter((item) => item.fileAssetIdValue)
        .map((item) => item.fileAssetIdValue);

      if (idsToQuery.length === 0) {
        return itemsWithUrl.map(({ fileAssetIdValue, ...rest }) => rest);
      }

      try {
        const res = await api.getFileConfigById(idsToQuery);
        const list = res && res.data && res.data.items ? res.data.items : [];
        const urlMap = {};
        list.forEach((f) => {
          urlMap[f.id] = f.url;
        });
        return itemsWithUrl.map((item) => {
          const { fileAssetIdValue, ...rest } = item;
          return {
            ...rest,
            thumbnailUrl: fileAssetIdValue ? (urlMap[fileAssetIdValue] || "") : item.thumbnailUrl
          };
        });
      } catch (e) {
        console.error("获取缩略图失败:", e);
        return itemsWithUrl.map(({ fileAssetIdValue, ...rest }) => rest);
      }
    },
    async getList() {
      if (!this.moduleId) return;
      this.loading = true;
      const { customSort, title, tagIds, publisherIds, resourceType, status, ...rest } = this.searchForm || {};
      let sortBy;
      let orderBy;
      if (customSort) {
        const arr = String(customSort).split("#");
        sortBy = arr[0];
        orderBy = arr[1];
      }

      const reqParams = {
        ...this.params,
        ...(title ? { title } : {}),
        ...(tagIds && tagIds.length ? { tagIds } : {}),
        ...(publisherIds && publisherIds.length ? { publisherIds } : {}),
        ...(resourceType ? { resourceType } : {}),
        ...(status !== null && status !== undefined && status !== "" ? { status } : {}),
        ...(sortBy && orderBy ? { sortBy, orderBy } : {})
      };

      const res = await api.getIndexConfigModulesResourceList(this.moduleId, reqParams);
      const items = (res.data && res.data.items) ? res.data.items : [];
      const hydrated = await this.hydrateCardThumb(items);
      this.dataList = hydrated.map((it) => {
        const titleText = valueByLanguage(it.title, "zh_CN", true) || "-";
        const thumbnailBadgeText = valueByLanguage(it.thumbnailBadge, "zh_CN", true) || "";
        const sloganText = valueByLanguage(it.slogan, "zh_CN", true) || "";
        return {
          ...it,
          shipId: it.shipId || it.id || it.ship_id,
          resourceTypeText: this.getResourceTypeText(it.resourceType),
          thumbnailBadgeText,
          titleText,
          sloganText,
          publisherName: (it.publisher && it.publisher.name) ? it.publisher.name : "-",
          pushText: this.getPushText(it.pushConditions),
          navText: this.getNavText(it.navigationConfig),
          createdAtText: this.formatDateTime(it.createdAt),
          statusText: this.getOnlineStatusText(it.status)
        };
      });
      this.total = (res.data && res.data.count) ? res.data.count : 0;
      this.loading = false;
      // 数据加载完成后重新计算表格高度并刷新布局
      this.calcTableHeight();
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    calcTableHeight() {
      this.$nextTick(() => {
        const tableWrapper = this.$el.querySelector(".table-wrapper");
        const pager = this.$el.querySelector(".pager");
        if (tableWrapper && pager) {
          // 计算表格高度：容器高度 - 分页器高度 - 分页器 margin
          const wrapperHeight = tableWrapper.clientHeight;
          const pagerHeight = pager.offsetHeight || 50;
          const pagerMargin = 12; // pager 的 margin-top
          this.tableHeight = wrapperHeight - pagerHeight - pagerMargin;
          // 确保最小高度
          if (this.tableHeight < 200) {
            this.tableHeight = 200;
          }
        } else if (tableWrapper) {
          // 如果没有分页器，预留空间
          this.tableHeight = tableWrapper.clientHeight - 50;
          if (this.tableHeight < 200) {
            this.tableHeight = 200;
          }
        }
        // 延迟执行 doLayout，确保 DOM 已更新
        this.$nextTick(() => {
          if (this.$refs.tableRef) {
            this.$refs.tableRef.doLayout();
          }
        });
      });
    },
    handleResize() {
      this.calcTableHeight();
    },
    handleSearch() {
      this.params.page = 1;
      this.getList();
    },
    resetSearch() {
      this.searchForm = {
        title: "",
        tagIds: [],
        publisherIds: [],
        resourceType: "",
        status: "",
        customSort: ""
      };
      this.handleSearch();
    },
    handleAddMaterial() {
      // 对齐 galaxy：必须选中模块才能添加素材
      if (!this.moduleId) {
        this.$message.warning("请先选择模块");
        return;
      }
      this.addMaterialVisible = true;
    },
    handleAddMaterialSuccess() {
      this.addMaterialVisible = false;
      // 对齐 galaxy：添加素材成功后重置分页并刷新列表
      this.params.page = 1;
      this.getList();
    },
    toUploadData(row) {
      this.uploadDetailId = row && row.id ? row.id : null;
      this.uploadVisible = true;
    },
    handleUploadClose() {
      this.uploadVisible = false;
    },
    handleUploadDialogClosed() {
      // 对齐 galaxy：关闭弹窗时清空 detailId，避免下次打开时仍显示编辑状态
      this.uploadDetailId = null;
    },
    handleUploadSuccess() {
      this.uploadVisible = false;
      this.uploadDetailId = null;
      // 对齐 galaxy：上传/编辑合集卡片成功后重置分页并刷新列表
      this.params.page = 1;
      this.getList();
    },
    openTest(row) {
      this.testDetailId = row && row.id;
      this.testVisible = true;
    },
    async testConfirm(data) {
      await api.testCardMaterial(this.testDetailId, data);
      this.$message.success("测试成功");
      this.testVisible = false;
    },
    async handleOffline(row) {
      // galaxy：0/2 -> 上线(1)，1 -> 下线(2)
      const status = [0, 2].includes(row && row.status) ? 1 : 2;
      await api.updateCardMaterialStatus(row.id, { status });
      this.$message.success(status === 1 ? "上线成功" : "下线成功");
      this.getList();
    },
    async copyLink(row) {
      try {
        const url = `${getServerUrl()}/library/material/detail`;
        const text = `${url}?id=${row.uniqueId}&lang=zh&type=${row.resourceType}`;
        await navigator.clipboard.writeText(text);
        this.$message.success("复制成功，请在浏览器粘贴");
      } catch (e) {
        this.$message.error("复制失败");
      }
    },
    removeResource(row) {
      this.$confirm("确认移除该资源？", "提示")
        .then(async () => {
          await api.removeIndexConfigModulesResource(this.moduleId, {
            itemIds: [row.id],
            resourceType: row.resourceType
          });
          this.$message.success("移除成功");
          this.getList();
        })
        .catch(() => { });
    },
    initSortable(e) {
      if (e && e.preventDefault) e.preventDefault();

      const wrapper = document.querySelector(".el-table__body-wrapper tbody");
      if (!wrapper) return;

      // 如果已存在实例且绑定到同一个元素，则不再创建
      if (this.sortableInstance) {
        return;
      }

      this.sortableInstance = Sortable.create(wrapper, {
        animation: 150,
        handle: ".drag-btn",
        onEnd: async ({ newIndex, oldIndex }) => {
          if (oldIndex === newIndex) return;

          try {
            const currentNode = this.dataList.splice(oldIndex, 1)[0];
            this.dataList.splice(newIndex, 0, currentNode);

            const newArray = [...this.dataList];
            this.dataList = [];
            await this.$nextTick();
            this.dataList = newArray;

            const newOrdinal = calculateDynamicOrdinal(newIndex, this.dataList);

            if (newOrdinal === null) {
              const list = resetDataOrdinal({
                dataList: this.dataList,
                page: this.params.page
              });
              await Promise.all(
                list.map((item) =>
                  api.updateIndexConfigModulesResourceOrdinal(item.shipId, {
                    ordinal: item.ordinal
                  })
                )
              );
              this.dataList = list;
              return;
            }

            currentNode.ordinal = newOrdinal;
            await api.updateIndexConfigModulesResourceOrdinal(currentNode.shipId, {
              ordinal: newOrdinal
            });
          } catch (error) {
            console.error("拖拽排序失败:", error);
          }
        }
      });
    },
    openOptRecord(row) {
      this.detailShipId = row && row.shipId;
      this.optRecordVisible = true;
    },
    // 模块 CRUD
    async openModuleDialog(item) {
      if (item && item.id) {
        const res = await api.getIndexConfigModulesDetails(item.id);
        this.moduleDetails = res.data;
        this.moduleForm = {
          name: (res.data && res.data.name) ? res.data.name : getDefaultLanguageData()
        };
      } else {
        this.moduleDetails = null;
        this.moduleForm = { name: getDefaultLanguageData() };
      }
      this.moduleDialogVisible = true;
    },
    resetModuleForm() {
      this.moduleDetails = null;
      this.moduleForm = { name: getDefaultLanguageData() };
    },
    async confirmModuleDialog() {
      // 走表单校验，确保至少简体名称必填
      this.$refs.moduleFormRef.validate(async (valid) => {
        if (!valid) return;
        const payload = {
          name: this.moduleForm.name,
          resourceType: "RESOURCE",
          type: "2"  // BANNER = "1", CARD = "2"
        };
        if (this.moduleDetails && this.moduleDetails.id) {
          await api.updateIndexConfigModules(this.moduleDetails.id, payload);
        } else {
          await api.addIndexConfigModules(payload);
        }
        this.$message.success("操作成功");
        this.moduleDialogVisible = false;
        await this.getModules();
      });
    },
    deleteModule(item) {
      this.$confirm("确认要删除吗?", "提示")
        .then(async () => {
          await api.delIndexConfigModules(item.id);
          this.$message.success("删除成功");
          await this.getModules();
          if (this.moduleId === item.id) {
            this.moduleId = this.moduleData.length ? this.moduleData[0].id : null;
          }
        })
        .catch(() => { });
    }
  }
};
</script>

<style scoped>
.card-material-library {
  height: 100%;
  overflow: hidden;
}

.library-body {
  display: flex;
  flex: 1;
  height: 100%;
  overflow: hidden;
}

.module-tree {
  width: 250px;
  min-width: 250px;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.module-tree-header {
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
}

.module-tree-add-icon,
.module-tree-add-text {
  color: #409eff;
  font-size: 14px;
  font-weight: 500;
}

.module-tree-content {
  flex: 1;
  overflow: hidden;
}

.module-tree-scroll {
  height: 100%;
  overflow: auto;
}

/* 选中节点样式 */
:deep(.el-tree-node.is-current > .el-tree-node__content) {
  background-color: #f0f0f0;
}

:deep(.el-tree-node__content) {
  padding: 0 8px;
  height: auto;
  min-height: 40px;
}

:deep(.el-tree-node__content:hover) {
  background-color: #f5f5f5;
}

.module-tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  padding: 8px 0;
}

.module-tree-node-label {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
  padding-right: 8px;
}

.module-tree-node-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 8px;
  flex-shrink: 0;
}

.module-tree-node-del {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: #f56c6c;
  color: #fff;
  border-radius: 2px;
  font-size: 12px;
  cursor: pointer;
  transition: opacity 0.2s;
  flex-shrink: 0;
}

.module-tree-node-del:hover {
  opacity: 0.8;
}

.module-tree-node-edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: #409eff;
  color: #fff;
  border-radius: 2px;
  font-size: 12px;
  cursor: pointer;
  transition: opacity 0.2s;
  flex-shrink: 0;
}

.module-tree-node-edit:hover {
  opacity: 0.8;
}

.module-form-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.module-form-label .req {
  color: #f56c6c;
}

.module-name-grid {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.module-name-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.module-name-lang {
  width: 40px;
  text-align: left;
  color: #606266;
  flex-shrink: 0;
}

.main-panel {
  flex: 1;
  min-width: 0;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.search-bar {
  flex-shrink: 0;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

.search-custom-btn {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.table-area {
  margin-top: 16px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.table-wrapper :deep(.el-table) {
  flex: 1;
  border: 1px solid #ebeef5;
}

.table-wrapper :deep(.el-table .el-table__fixed-right::before) {
  display: none;
}

.table-wrapper :deep(.el-table__body-wrapper) {
  overflow-x: auto !important;
  overflow-y: auto !important;
  max-height: none !important;
}

.table-wrapper :deep(.el-table__body-wrapper)::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.table-wrapper :deep(.el-table__body-wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

.table-wrapper :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
  transition: background-color 0.2s ease;
}

.table-wrapper:hover :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.3);
}

.table-wrapper:hover :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, 0.5);
}

.table-wrapper :deep(.el-table__body-wrapper) {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  transition: scrollbar-color 0.2s ease;
}

.table-wrapper:hover :deep(.el-table__body-wrapper) {
  scrollbar-color: rgba(144, 147, 153, 0.3) transparent;
}

.pager {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.thumb-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.thumb-img {
  height: 40px;
  max-width: 100px;
  object-fit: fill;
  display: block;
}

.thumb-placeholder {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  color: #909399;
  font-size: 12px;
  padding: 0 8px;
}

.tag-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  width: 100%;
  overflow: hidden;
}

.tag-pill {
  color: #67c23a;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  padding: 0 6px;
  max-width: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.op-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: nowrap;
}

.op-drag {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  position: relative;
}

.drag-btn {
  cursor: grab;
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  color: #606266;
  transition: color 0.2s;
  pointer-events: auto;
  touch-action: none;
  user-select: none;
  position: relative;
}

.drag-btn:hover {
  color: #409eff;
}

.drag-btn:active {
  cursor: grabbing;
}

.op-row :deep(.el-button--small) {
  padding: 6px 10px;
}

.lang-form-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.lang-label {
  width: 60px;
  text-align: left;
  color: #606266;
}

:deep(.add-material-dialog.el-dialog) {
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 0;
}

:deep(.add-material-dialog.el-dialog .el-dialog__header) {
  flex-shrink: 0;
}

:deep(.add-material-dialog.el-dialog .el-dialog__body) {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

:deep(.add-material-dialog.el-dialog .el-dialog__body > .add-material) {
  flex: 1;
  min-height: 0;
}
</style>
